/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ScheduledMuscle interface.
 */
export function instanceOfScheduledMuscle(value) {
    if (!("id" in value) || value.id === undefined)
        return false;
    if (!("regenerationSlope" in value) || value.regenerationSlope === undefined)
        return false;
    return true;
}
export function ScheduledMuscleFromJSON(json) {
    return ScheduledMuscleFromJSONTyped(json, false);
}
export function ScheduledMuscleFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json.id,
        regenerationSlope: json.regenerationSlope,
    };
}
export function ScheduledMuscleToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value.id,
        regenerationSlope: value.regenerationSlope,
    };
}
